// src/api/landingApi.ts
import apiClient from './axios.config';

export interface LandingInterestPayload {
  name: string;
  email: string;
  company: string;
  useCase?: string;
}

export interface LandingInterestResponse {
  id?: string;
  message?: string;
}

export const landingApi = {
  submitInterest: async (payload: LandingInterestPayload): Promise<LandingInterestResponse> => {
    const { data } = await apiClient.post('/landing/interests', payload);
    return data;
  },
};

export default landingApi;
